'use strict';

var _ = require('lodash');
var PooledReviewCalendarService = function PooledReviewCalendarService($q, restangular, $log, configurationService, liteDataService, cacheService, seasonalityReviewConstants) {
  function getCabinClassGroups(market) {
    var serviceClassGroupConfig = configurationService.getClassGroupConfig();
    var mappings = _.get(serviceClassGroupConfig, market, serviceClassGroupConfig["default"]);
    return _.groupBy(mappings, 'cabinCode');
  }
  function getCabins(cabinClassGroups) {
    return _.keys(cabinClassGroups);
  }
  function getDowGroups() {
    return seasonalityReviewConstants.DOW_GROUPS;
  }
  function getUsableDowGroup(dowGroup) {
    return _.get(seasonalityReviewConstants.DOW_DISPLAY_TO_USAGE, dowGroup);
  }
  function getDayOfWeek(dow) {
    return _.get(seasonalityReviewConstants.DAY_OF_WEEK_MAPPING, dow);
  }
  function fetchHepProfiles(profileType, filters, localFilter, calendarName) {
    var baseURL = calendarName ? seasonalityReviewConstants.ENDPOINT_URL.HEP_CALENDAR_NAME_URL : seasonalityReviewConstants.ENDPOINT_URL.HEP_ALL_URL;
    return getHepData(baseURL, buildRSQLFilter(filters), profileType, calendarName).then(function (hepList) {
      if (_.isArray(hepList) && hepList.length > 0 && localFilter) {
        _.forEach(localFilter, function (filterObject) {
          hepList = _.filter(hepList, function (hep) {
            return _.includes(filterObject.filter, _.get(hep, filterObject.attribute));
          });
        });
      }
      return hepList;
    });
  }
  function getSimpleHepConfig(simpleHepKey) {
    var endpoint = seasonalityReviewConstants.ENDPOINT_URL.HEP_SIMPLE + simpleHepKey;
    var cachedData = cacheService.getData(endpoint);
    $log.debug('Cache exists for Simple Hep ' + endpoint + '? ' + !_.isUndefined(cachedData));
    var promise = cachedData ? $q.when(cachedData) : liteDataService.get(endpoint);
    return promise.then(function (simpleHep) {
      return simpleHep.content;
    })["catch"](function (e) {
      $log.error('PooledReviewCalendarService - getSimpleHepConfig() ' + e);
      return '';
    });
  }
  function buildRSQLFilter(filterObject) {
    return _.chain(filterObject).keys(filterObject).reduce(function (filters, key) {
      var filterData = _.get(filterObject, key);
      var filterString;
      if (key === 'departureDate') {
        return filters.concat(buildDateRSQLFilter(key, filterData));
      } else {
        if (_.isArray(filterData)) {
          var joinedString = _.join(filterData, ',');
          filterString = key + seasonalityReviewConstants.RSQL_OPERATORS.MULTI + '(' + joinedString + ')';
        } else {
          filterString = key + seasonalityReviewConstants.RSQL_OPERATORS.SINGLE + '\'' + filterData + '\'';
        }
      }
      return filters.concat(filterString);
    }, []).join(';').value();
  }
  function buildDateRSQLFilter(key, dates) {
    if (_.isArray(dates)) {
      var dateFilter = [];
      var startDate = dates[0];
      var endDate = dates[1];
      if (!_.isUndefined(startDate)) {
        dateFilter.push(key + seasonalityReviewConstants.RSQL_OPERATORS.GREATER_THAN + startDate.toISOString());
      }
      if (!_.isUndefined(endDate)) {
        dateFilter.push(key + seasonalityReviewConstants.RSQL_OPERATORS.LESSER_THAN + endDate.toISOString());
      }
      return dateFilter;
    } else {
      return key + seasonalityReviewConstants.RSQL_OPERATORS.SINGLE + dates.toISOString();
    }
  }
  function getMarketRTP(origin, destination) {
    var filters = 'origin==' + origin + ';destination==' + destination;
    return getHepData(seasonalityReviewConstants.ENDPOINT_URL.HEP_URL, filters, seasonalityReviewConstants.HEP.RTP).then(function (hepList) {
      var rtpData = hepList[0];
      return rtpData.properties.readingDays.map(function (readingDays) {
        return readingDays.days.toString();
      });
    })["catch"](function (e) {
      return false;
    });
  }
  function getHepData(baseUrl, filters, type, calendarName) {
    var request = {
      pageLimit: seasonalityReviewConstants.DEFAULT_PAGE_LIMIT,
      filter: filters
    };
    if (calendarName) {
      request.calendarName = calendarName;
    }
    var endpoint = baseUrl + type;
    var cachedData = cacheService.getData(endpoint, request.filter);
    $log.debug('Cache exists for Hep Url ' + endpoint + '? ' + !_.isUndefined(cachedData));
    var promise = cachedData ? $q.when(cachedData) : liteDataService.get(endpoint, request);
    return promise.then(function (response) {
      cacheService.putData(endpoint, request.filter, response);
      return response.hepList;
    })["catch"](function (e) {
      return false;
    });
  }
  function saveOutliersToDB(outlierDocs) {
    var request = {
      value: outlierDocs
    };
    cacheService.invalidate();
    return liteDataService.put(seasonalityReviewConstants.ENDPOINT_URL.SAVE_OUTLIERS, request);
  }
  function getMarketCabinOutliers(filter, localFilter) {
    var request = {
      pageLimit: 10000,
      filter: buildRSQLFilter(filter)
    };
    var endpoint = seasonalityReviewConstants.ENDPOINT_URL.GET_OUTLIERS;
    var cachedData = cacheService.getData(endpoint, request.filter);
    $log.debug('Cache exists for Outlier Url ' + endpoint + '? ' + !_.isUndefined(cachedData));
    var promise = cachedData ? $q.when(cachedData) : liteDataService.get(endpoint, request);
    return promise.then(function (response) {
      cacheService.putData(endpoint, request.filter, response);
      var outliers = response.marketSeasonAndOutlier;
      if (_.isArray(outliers) && outliers.length > 0 && localFilter) {
        return _.filter(outliers, function (outlier) {
          return _.get(outlier, localFilter.attribute, false);
        });
      }
      return outliers;
    })["catch"](function (e) {
      return false;
    });
  }
  function getMarketCalendar(filter) {
    var request = {
      filter: buildRSQLFilter(filter)
    };
    var endpoint = seasonalityReviewConstants.ENDPOINT_URL.GET_CALENDAR;
    var cachedData = cacheService.getData(endpoint, request.filter);
    $log.debug('Cache exists for get calendar url ' + endpoint + '? ' + !_.isUndefined(cachedData));
    var promise = cachedData ? $q.when(cachedData) : liteDataService.get(endpoint, request);
    return promise.then(function (response) {
      cacheService.putData(endpoint, request.filter, response);
      return response.analysis;
    })["catch"](function (e) {
      return false;
    });
  }
  return {
    getCabinClassGroups: getCabinClassGroups,
    getCabins: getCabins,
    getDowGroups: getDowGroups,
    getMarketRTP: getMarketRTP,
    fetchHepProfiles: fetchHepProfiles,
    getSimpleHepConfig: getSimpleHepConfig,
    getUsableDowGroup: getUsableDowGroup,
    getDayOfWeek: getDayOfWeek,
    buildRSQLFilter: buildRSQLFilter,
    saveOutliersToDB: saveOutliersToDB,
    getMarketCabinOutliers: getMarketCabinOutliers,
    getMarketCalendar: getMarketCalendar
  };
};
PooledReviewCalendarService.$inject = ['$q', 'Restangular', '$log', 'ConfigurationService', 'LiteDataService', 'PooledSeasonalityDataCacheService', 'PooledSeasonalityReviewConstants'];
module.exports = PooledReviewCalendarService;